export default __webpack_public_path__ + "static/3-109db3bae6648cf5eae3ddb9e3098166.jpeg";